export const ACCESS_TYPE = "ws"; // ws or sse 标志链接方式

// 默认应用配置（降级使用）
export const DEFAULT_APP_CONFIG = {
    app_name: "数智元创",
    avatar: "static/logo.png",
    desc: "数字智能助手",
    style: "background: linear-gradient(271.81deg, #305af5 0%, #309cff 52.76%, #00d0e9 100%)",
    is_available: true,
    bot_biz_id: "1664579228250451968",
};

export const APP_KEY = "WUTSAQZI"; // 体验机器人的appkey



// WEBPACK FOOTER //
// ./src/constants/static.js